import { Icon, Typography } from "@/components/atoms";
import { BlockedDriver } from "@/redux/apis/clientDispatch/types";
import { UnblockDriverAction } from "./components/UnblockDriverAction";
import { BlockedDriversTableData } from "./types";

export const generateBlockedDriversData = (drivers: BlockedDriver[], accountId?: string): BlockedDriversTableData[] =>
  drivers.map((driver) => ({
    driverId: <Typography>{driver.driverId}</Typography>,
    driverName: (
      <div className="flex items-center gap-2.5">
        <Icon name="forbidden" isCustom size="sm" className="flex-shrink-0 text-neutral-black" />
        <Typography>{driver.driverName}</Typography>
      </div>
    ),
    reason: (
      <Typography className="block max-w-[320px] truncate" title={driver.reason}>
        {driver.reason}
      </Typography>
    ),
    action: <UnblockDriverAction driver={driver} accountId={accountId} />,
  }));
